<template>
  <p>
    <span v-if="plan?.IsStudent">Student </span>
    <span aria-hidden="true"
      >med
      <span v-if="regularAllowanceString" class="strike-through me-2">
        {{ regularAllowanceString }}
      </span>
      {{ allowanceString }} surf</span
    >
    <span v-if="!!plan" class="sr-only">
      med {{ plan?.PlanName }} abonnemang.
    </span>
  </p>
</template>

<script lang="ts" setup>
import type { AggregatedPlanDto } from '~/models/ListingProduct.api.model';

interface Props {
  plan?: AggregatedPlanDto;
}

const props = defineProps<Props>();

const allowanceString = computed(() => {
  return props.plan?.DataAllowance
    ? `${props.plan?.DataAllowance}GB`
    : props.plan?.PlanName;
});

const regularAllowanceString = computed(() => {
  return props.plan?.RegularDataAllowance || '';
});
</script>
